export default __webpack_public_path__ + "e2515ea.png";